import type { CampaignType } from './types';

export function hasBeenStarted(campaign: CampaignType) {
  const { startDateTime, endDateTime } = campaign;
  return !!startDateTime && !!endDateTime;
}
